import React, { HTMLAttributes, useCallback } from 'react';
import classNames from 'classnames';
import styles from './Fieldset.module.scss';

export interface IFieldset extends HTMLAttributes<HTMLDivElement> {
  title: string;
  disabled?: boolean;
  onRemove: (name: string) => void;
  hideRemoveButton?: boolean;
}

const Fieldset: React.FC<IFieldset> = (props) => {
  const {
    title,
    onRemove = () => {},
    children,
    className,
    hideRemoveButton = false,
    disabled,
  } = props;
  const rootClassName = classNames(styles.root, className, { [styles.disabled]: disabled });

  const handleRemoveClick = useCallback(() => {
    onRemove(title);
  }, [onRemove, title]);

  return (
    <div className={rootClassName}>
      <div className={styles.fieldset}>
        {title}
        {!hideRemoveButton && (
          <button className={styles.removeButton} type='button' onClick={handleRemoveClick}>
            <span className='fas fa-trash-alt'></span>
          </button>
        )}
      </div>
      {children}
    </div>
  );
};

export default Fieldset;
